import React, { useState, useEffect } from "react";
import examQuestions from "../data/examQuestions";

const Practice = () => {
  const [questionsPool, setQuestionsPool] = useState([...examQuestions]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [answeredQuestions, setAnsweredQuestions] = useState(0);

  useEffect(() => {
    if (answeredQuestions >= 200) {
      alert("Ukończyłeś wszystkie pytania! Czy chcesz zacząć od nowa?");
      setQuestionsPool([...examQuestions]);
      setAnsweredQuestions(0);
    }
  }, [answeredQuestions]);

  const getNextQuestion = () => {
    if (questionsPool.length === 0) {
      alert("Przerobiliśmy wszystkie pytania! Zaczynamy od nowa.");
      setQuestionsPool([...examQuestions]);
      setAnsweredQuestions(0);
      return;
    }

    const randomIndex = Math.floor(Math.random() * questionsPool.length);
    const nextQuestion = questionsPool[randomIndex];
    const updatedPool = questionsPool.filter((_, index) => index !== randomIndex);

    setCurrentQuestion(nextQuestion);
    setQuestionsPool(updatedPool);
    setSelectedAnswer(null);
    setIsCorrect(null);
  };

  const handleAnswerClick = (answerKey) => {
    setSelectedAnswer(answerKey);
    if (answerKey === currentQuestion.correct) {
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
    }
    setAnsweredQuestions((prev) => prev + 1);
  };

  return (
    <div className="practice">
      <div className="practice__progress-bar-container">
        <div
          className="practice__progress-bar"
          style={{ width: `${(answeredQuestions / 200) * 100}%` }}
        >
          {answeredQuestions} / 200
        </div>
      </div>
      <div className="practice__container">
        {currentQuestion ? (
          <>
            <h3 className="practice__question">{currentQuestion.question}</h3>
            <ul className="practice__answers">
              {Object.entries(currentQuestion.answers).map(([key, answer]) => (
                <li key={key} className="practice__answer-item">
                  <button
                    className={`practice__answer-button ${
                      selectedAnswer === key
                        ? key === currentQuestion.correct
                          ? "correct"
                          : "incorrect"
                        : ""
                    } ${
                      selectedAnswer !== null && key === currentQuestion.correct && !isCorrect
                        ? "show-correct"
                        : ""
                    }`}
                    onClick={() => handleAnswerClick(key)}
                    disabled={selectedAnswer !== null}
                  >
                    {key.toUpperCase()}. {answer}
                  </button>
                  {/* Wyświetlanie wyjaśnień */}
                  {selectedAnswer === key && !isCorrect && (
                    <p className="practice__explanation">
                      {currentQuestion.explain[key]}
                    </p>
                  )}
                  {selectedAnswer !== null && key === currentQuestion.correct && (
                    <p className="practice__explanation practice__explanation--correct">
                      {currentQuestion.rightAnswer}
                    </p>
                  )}
                </li>
              ))}
            </ul>
            {selectedAnswer && (
              <button className="practice__next-button" onClick={getNextQuestion}>
                Następne pytanie
              </button>
            )}
          </>
        ) : (
          <button className="practice__next-button" onClick={getNextQuestion}>
            Rozpocznij ćwiczenie
          </button>
        )}
      </div>
    </div>
  );
};

export default Practice;
